module.exports = __webpack_public_path__ + "media/kingofkpop.998e8ecd.mp4";